/**
 * GlobalNotifications — Renders all notifications from Redux as a Flashbar.
 * Place this once in the App layout. Pages just dispatch addNotification().
 */
import Flashbar from '@cloudscape-design/components/flashbar';
import { useAppSelector, useAppDispatch } from 'src/store/hooks';
import { dismissNotification } from 'src/store/slices/notifications/notificationSlice';

export const GlobalNotifications = () => {
  const dispatch = useAppDispatch();
  const items = useAppSelector(state => state.notifications.items);

  if (items.length === 0) return null;

  return (
    <Flashbar
      items={items.map(n => ({
        type: n.type,
        header: n.header,
        content: n.content,
        dismissible: n.dismissible !== false,
        id: n.id,
        onDismiss: () => dispatch(dismissNotification(n.id)),
      }))}
    />
  );
};
